import React, { createContext, useContext, useId } from 'react'
import { Form, FormikFormProps } from 'formik'
import RouteLeavingGuard from '../layout/RouteLeavingGuard'

const FormIdContext = createContext<string | undefined>(undefined)
FormIdContext.displayName = 'FormIdContext'

export const useFormId = (): string | undefined => useContext(FormIdContext)

const FormWithRouteLeavingGuard: React.FC<FormikFormProps> = ({ children, ...props }) => {
  const generatedId = useId()
  const formId = props.id ?? generatedId

  return (
    <FormIdContext.Provider value={formId}>
      <Form {...props} id={formId}>
        <RouteLeavingGuard />
        {children}
      </Form>
    </FormIdContext.Provider>
  )
}

export default FormWithRouteLeavingGuard
